import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AboutPage() {
  const orgStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '桃花影院',
    url: 'https://taohua-cinema.com',
    description: '桃花影院 - 免费在线电影院，高清不缓冲，永久免费无需会员。提供最新电影、热播电视剧、热门综艺免费在线观看。',
    sameAs: [
      'https://weibo.com/taohua-cinema',
      'https://www.douyin.com/user/taohua-cinema',
    ],
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'service@taohua-cinema.com',
      availableLanguage: ['Chinese'],
    },
  };

  const breadcrumbStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'https://taohua-cinema.com',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '关于我们',
        item: 'https://taohua-cinema.com/about',
      },
    ],
  };

  const stats = [
    { value: '100,000+', label: '影视资源' },
    { value: '5,000万+', label: '月活跃用户' },
    { value: '99.9%', label: '播放成功率' },
    { value: '7x24', label: '内容更新' },
  ];

  const features = [
    {
      icon: 'ri-shield-check-line',
      title: '永久免费',
      desc: '无需注册会员，无需付费订阅，所有影视内容永久免费在线观看。',
    },
    {
      icon: 'ri-4k-line',
      title: '高清画质',
      desc: '支持1080P超清画质，部分热门影片支持4K，观影体验媲美影院。',
    },
    {
      icon: 'ri-speed-up-line',
      title: '极速播放',
      desc: '采用CDN加速技术，全国多节点覆盖，播放流畅不缓冲不卡顿。',
    },
    {
      icon: 'ri-smartphone-line',
      title: '多端适配',
      desc: '全面支持电脑、平板和手机，随时随地打开浏览器即可观影。',
    },
    {
      icon: 'ri-refresh-line',
      title: '实时更新',
      desc: '24小时不间断更新，热播剧同步追更，新片下线即上线。',
    },
    {
      icon: 'ri-user-heart-line',
      title: '用户至上',
      desc: '以用户体验为核心，简洁界面设计，让观影回归纯粹享受。',
    },
  ];

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbStructuredData) }}
      />
      <Navbar />
      <main className="pt-20">
        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-7xl mx-auto text-center">
            <nav className="flex items-center justify-center gap-2 text-sm text-foreground-400 mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
              <span>/</span>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              关于桃花影院
            </h1>
            <p className="text-foreground-500 max-w-3xl mx-auto leading-relaxed">
              桃花影院成立于2023年，是国内领先的免费在线观影平台。我们致力于打破传统影视平台的付费壁垒，让每一位热爱电影电视剧的用户都能免费、便捷地享受高品质的观影体验。无需注册、无需会员、无需付费——打开即看，这是桃花影院不变的承诺。
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
              我们的优势
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {features.map((feature) => (
                <div key={feature.title} className="p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-colors">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mb-4">
                    <i className={`${feature.icon} text-primary-500 text-xl`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-7xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-4">
              信誉保障
            </h2>
            <p className="text-foreground-500 text-center max-w-3xl mx-auto mb-10 leading-relaxed">
              桃花影院自上线以来，始终坚持合法合规运营，获得了广大用户的信赖与好评。我们郑重承诺：
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  icon: 'ri-lock-line',
                  title: '隐私安全保障',
                  desc: '无需注册即可观影，不收集用户个人信息，保护您的隐私安全。',
                },
                {
                  icon: 'ri-bill-line',
                  title: '免费承诺',
                  desc: '永久免费，绝无隐藏收费，所有内容均可免费在线观看。',
                },
                {
                  icon: 'ri-customer-service-2-line',
                  title: '优质服务',
                  desc: '7x24小时客服支持，及时响应用户反馈，持续优化观影体验。',
                },
              ].map((item) => (
                <div key={item.title} className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-accent-100 mb-4">
                    <i className={`${item.icon} text-accent-500 text-xl`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 mb-4">
                  <i className="ri-mail-line text-primary-500 text-xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">电子邮箱</h3>
                <p className="text-sm text-foreground-500">
                  商务合作：<a href="mailto:business@taohua-cinema.com" className="text-primary-500 hover:text-primary-600 cursor-pointer">business@taohua-cinema.com</a>
                </p>
                <p className="text-sm text-foreground-500 mt-1">
                  客服支持：<a href="mailto:service@taohua-cinema.com" className="text-primary-500 hover:text-primary-600 cursor-pointer">service@taohua-cinema.com</a>
                </p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
                  <i className="ri-chat-smile-2-line text-accent-500 text-xl"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">社交媒体</h3>
                <div className="flex items-center gap-4 mt-2">
                  <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" rel="nofollow">
                    <i className="ri-weibo-line text-xl"></i>
                  </a>
                  <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" rel="nofollow">
                    <i className="ri-wechat-line text-xl"></i>
                  </a>
                  <a href="#" className="w-10 h-10 flex items-center justify-center rounded-full bg-background-100 text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors cursor-pointer" rel="nofollow">
                    <i className="ri-tiktok-line text-xl"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}